import PropTypes from 'prop-types';

import { Box, CardContent, Link } from '@mui/material';
import {
  FocusCardStyled,
  FocusTitle,
  FocusCount,
  ReleaseTitle,
  ReleaseArtist,
  ReleaseDetails,
  ReleaseCardStyled,
  ReleaseLabel,
} from './DashboardStyles';

import i18n from '@/i18n'
import { Link as ReactLink } from 'react-router-dom';
import { PitchCard } from './PitchCard';

export function FocusPitchesCard({ pitches, focusCount }) {
  return (
    <FocusCardStyled>
      <CardContent sx={{ padding: 0, '&:last-child': { paddingBottom: 0 } }}>
        <FocusTitle>
          {i18n.t('focus-label-pipeline')}
          <FocusCount>{focusCount}/week</FocusCount>
        </FocusTitle>
        <Box>
          {pitches?.map((pitch, index) => {
            return (
              <PitchCard {...pitch} />
            );
          })}
        </Box>
      </CardContent>
    </FocusCardStyled>
  );
}

FocusPitchesCard.propTypes = {
  pitches: PropTypes.arrayOf(
    PropTypes.shape({
      release: PropTypes.shape({
        name: PropTypes.string.isRequired,
        artists: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string.isRequired
          })
        ),
        label: PropTypes.shape({
          name: PropTypes.string.isRequired
        }),
        released: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired
      }),
      source: PropTypes.string.isRequired
    })
  ).isRequired,
  focusCount: PropTypes.number.isRequired,
};
